// Dependencies
import React, {useEffect} from "react";
import { Navigate, Routes, Route, useLocation } from "react-router-dom";
import { Provider } from "react-redux";
// import Analytics from "react-router-ga";
// import { GOOGLE_ANALYTICS_ID } from "./constants";

// Store
import createAppStore from "./configureStore";

// Components
import Header from "./components/header";
import Logo from "./components/logo";
import Breadcrumbs from "./components/breadcrumbs";
import Footer from "./components/footer";
import Home from "./screens/home/home";
import Dashboard from "./screens/dashboad/dashboard";
import DashboardLanding from "./screens/dashboardLanding/DashboardLanding";
import BalanceIndexScreen from "./screens/balance/balanceIndexScreen";
import BalanceShowScreen from "./screens/balance/balanceShowScreen";
import BalanceDetailScreen from "./screens/balance/balanceDetailScreen";
import BalanceEditScreen from "./screens/balance/balanceEditScreen";
import BalanceNewScreen from "./screens/balance/balanceNewScreen";
import OwnershipIndex from "./screens/ownership/index";
import OwnershipEdit from "./screens/ownership/edit";
import WealthMap from "./screens/ownership/wealth_map";
import WealthMapMobile from "./screens/ownership/wealth_map_mobile";
// import OwnershipCreate from './screens/ownership/create'
import OwnershipShow from "./screens/ownership/show";
import PrivateRoute from "./helpers/privateRoute";
import SignIn from "./screens/signin/signIn";
import SsoCallback from "./screens/signin/ssoCallback";
import DocumentsIndexScreen from "./screens/documents/documentsIndexScreen";
import DocumentsShowScreen from "./screens/documents/documentsShowScreen";
import DocumentsDetailScreen from "./screens/documents/documentsDetailScreen";
import NotificationsIndexScreen from "./screens/notifications/notificationsIndexScreen";
import BalanceValuationsScreen from "./screens/balance/valuations";
import ProfileEditScreen from "./screens/profile/profileIndexScreen";
import ProfileChangeScreen from "./screens/profile/profileChangeScreen";
import SearchIndexScreen from "./screens/search/searchIndexScreen";
import AlertsIndexScreen from "./screens/alerts/alertsIndexScreen";
import { handleGlobalBlurClass, toggleBlur } from "./helpers/blur";
import Recovery from "./screens/signin/recovery";
import Demo from "./screens/signin/demo";
import ServicesIndexScreen from "./screens/services/servicesIndexScreen";
import ServicesShowScreen from "./screens/services/servicesShowScreen";
import ServicesDetailScreen from "./screens/services/servicesDetailScreen";
import SideBar from "./screens/menu/sideBar";
import InProgress from "./components/inProgress";
import MarketIndexScreen from "./screens/market/marketIndexScreen";
import PodcastIndexScreen from "./screens/podcasts/PodcastIndexScreen";
import EstateMappingScreen from "./screens/estateMapping";
import TaxHarvesting from "./screens/taxHarvesting/TaxHarvesting";

import Video from "./screens/video";
import FinancialStatements from "./screens/financialStatements";

// Helpers
import { createBrowserHistory } from "history";

const customHistory = createBrowserHistory();
const store = createAppStore();

function App(props) {
  const location = useLocation();
  const isWorkspaceDashboard = location.pathname === "/dashboard";

  const _closeSideBar = (e) => {
    if (
      document.body.classList.contains("open-sidebar") &&
      e.currentTarget.className === "wrapper-main" &&
      !(
        e.target.closest(".burger-menu") !== null &&
        e.target.closest(".burger-menu").className === "burger-menu"
      )
    ) {
      document.body.classList.remove("open-sidebar");
    }
  };

  useEffect(() => {
    handleGlobalBlurClass();

    if (!props.force_blur) {
      window.addEventListener('click', toggleBlur);
    } else {
      window.removeEventListener('click', toggleBlur);
      document.body.classList.add("blur-forced")
    }

    return () => window.removeEventListener('click', toggleBlur);
  }, [props.force_blur])

  return (
    <Provider history={customHistory} store={store}>
      {/*<Analytics id={GOOGLE_ANALYTICS_ID} debug>*/}
        <main className="wrapper-main" onClick={(e) => _closeSideBar(e)}>
          {!isWorkspaceDashboard && <SideBar history={customHistory} />}
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<SignIn />} />
                <Route path="/recovery" element={<Recovery />} />
                <Route path="/sso/callback" element={<SsoCallback />} />
                <Route path="/demo" element={<Demo />} />
                <Route path="/wealth-map-mobile" element={<WealthMapMobile />} />

                {/* Private routes */}
                <Route
                  path="/home"
                  element={
                    <PrivateRoute header={Header} footer={Footer}>
                      <Home />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/pro"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <Dashboard />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <PrivateRoute minimal>
                      <DashboardLanding />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/pro/profile"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <ProfileEditScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/financial-statements"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <FinancialStatements />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/balance-index"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <BalanceIndexScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/balance-show"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <BalanceShowScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/balance-detail"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <BalanceDetailScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/balance-new"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <BalanceNewScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/balance-edit"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <BalanceEditScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/documents-index"
                  element={
                    <PrivateRoute header={Header} footer={Footer}>
                      <DocumentsIndexScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/documents-show"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <DocumentsShowScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/podcasts"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <PodcastIndexScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/document-detail"
                  element={
                    <PrivateRoute header={Header} footer={Footer}>
                      <DocumentsDetailScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/notifications"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <NotificationsIndexScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/valuations"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <BalanceValuationsScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/ownership-index"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <OwnershipIndex />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/wealth-map"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <WealthMap />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/ownership-edit"
                  element={
                    <PrivateRoute header={Header} footer={Footer}>
                      <OwnershipEdit />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/ownership_structure/:type/:id"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <OwnershipShow />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <ProfileEditScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/profile_edit"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <ProfileChangeScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/services/:id/files"
                  element={
                    <PrivateRoute header={Header} footer={Footer}>
                      <ServicesDetailScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/services/:id"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <ServicesShowScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/researchs/:id"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <ServicesShowScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/search"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <SearchIndexScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/market"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <MarketIndexScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/servicesProduct"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <InProgress />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/alerts"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <AlertsIndexScreen />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/inProgress"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <InProgress />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/tax-harvesting"
                  element={
                    <PrivateRoute header={Header} footer={Footer} breadcrumbs={Breadcrumbs}>
                      <TaxHarvesting />
                    </PrivateRoute>
                  }
                />
               <Route exact path="/video" component={Video} />
               <Route
                  path="/estate-mapping/"
                  element={<Navigate to="/" replace />}
                />
                <Route
                  path="/estate-mapping/:token"
                  element={
                    <EstateMappingScreen />
                  }
                />
            
            </Routes>

        </main>
      {/*</Analytics>*/}
    </Provider>
  );
}

export default App;
